import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useReservationItems } from "@/hooks/reservations/useReservationItems";
import { ArrowLeft, Clock, DollarSign } from "lucide-react";

interface ReservationItemsProps {
  categoryId: string;
  categoryName: string;
  onBack: () => void;
  onSelectItem: (item: any) => void;
}

export const ReservationItems = ({ categoryId, categoryName, onBack, onSelectItem }: ReservationItemsProps) => {
  const { data: items = [], isLoading } = useReservationItems(categoryId);

  if (isLoading) {
    return (
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" onClick={onBack}>
            <ArrowLeft className="h-4 w-4" />
          </Button>
          <h2 className="text-xl font-semibold">Cargando...</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {[...Array(2)].map((_, i) => (
            <Card key={i} className="animate-pulse">
              <CardHeader>
                <div className="h-4 bg-muted rounded w-3/4"></div>
              </CardHeader>
              <CardContent>
                <div className="h-32 bg-muted rounded mb-4"></div>
                <div className="h-4 bg-muted rounded w-1/2"></div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" onClick={onBack}>
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <h2 className="text-xl font-semibold">{categoryName}</h2>
      </div>

      {items.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-muted-foreground">
            No hay elementos disponibles para reservar en esta categoría.
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {items.map((item) => (
            <Card key={item.id} className="hover:shadow-lg transition-shadow">
              <CardHeader>
                <CardTitle className="flex items-center justify-between">
                  <span>{item.name}</span>
                  <div className="flex items-center text-sm text-muted-foreground">
                    <DollarSign className="h-4 w-4" />
                    <span>{item.price_per_hour}/hora</span>
                  </div>
                </CardTitle>
              </CardHeader>
              <CardContent>
                {item.image_url && (
                  <div className="aspect-video rounded-lg overflow-hidden mb-4">
                    <img 
                      src={item.image_url} 
                      alt={item.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                )}
                {item.description && (
                  <p className="text-sm text-muted-foreground mb-4">
                    {item.description}
                  </p>
                )}
                <Button 
                  onClick={() => onSelectItem(item)}
                  className="w-full"
                >
                  <Clock className="h-4 w-4 mr-2" />
                  Reservar aquí
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};